export const initTable = () => {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.m-stage__text table').forEach((table) => {
            if (!table.classList.contains('table') && !table.closest('.table-responsive')) {
                table.classList.add('table');
                const wrapper = document.createElement('div');
                wrapper.classList.add('table-responsive');
                table.parentNode?.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    });
};
